import React from 'react';

import TextField from './TextField';


/**
 * Currency input — numeric input with a leading `$` affordance, per the
 * DESIGN.md `currency-input` token (".pen Specialized-inputs" frame): 2-dp,
 * numeric keypad on phone, `$` rendered in ink-subtle.
 */
const CurrencyField = React.forwardRef((props, ref) => {
  const { leading = <span className="text-ink-subtle">$</span>, step = '0.01', ...restProps } = props;

  return (
    <TextField
      ref={ref}
      step={step}
      type="number"
      leading={leading}
      inputMode="decimal"
      {...restProps}
    />
  );
});

CurrencyField.displayName = 'CurrencyField';
export default CurrencyField;
